import * as tslib_1 from "tslib";
import { DeadlinesTimeline, DeadlinesWhere } from '@core/interfaces';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
var DeadlinesApi = /** @class */ (function () {
    function DeadlinesApi(apollo) {
        this.apollo = apollo;
    }
    DeadlinesApi.prototype.getResponseDeadlinesTimeline = function (where) {
        return this.apollo
            .query({
            query: gql(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n        query accountMaintenancesDeadlinesByDay($where: DeadlinesWhereInput!) {\n          accountMaintenancesDeadlinesByDay(where: $where) {\n            items {\n              day\n              firstVisitInPeriodCount\n              firstVisitOutPeriodCount\n              closedInPeriodCount\n              closedOutPeriodCount\n            }\n          }\n        }\n      "], ["\n        query accountMaintenancesDeadlinesByDay($where: DeadlinesWhereInput!) {\n          accountMaintenancesDeadlinesByDay(where: $where) {\n            items {\n              day\n              firstVisitInPeriodCount\n              firstVisitOutPeriodCount\n              closedInPeriodCount\n              closedOutPeriodCount\n            }\n          }\n        }\n      "]))),
            variables: {
                where: where
            }
        })
            .pipe(map(function (response) {
            return response.data['accountMaintenancesDeadlinesByDay']['items'];
        }));
    };
    DeadlinesApi.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DeadlinesApi_Factory() { return new DeadlinesApi(i0.ɵɵinject(i1.Apollo)); }, token: DeadlinesApi, providedIn: "root" });
    return DeadlinesApi;
}());
export { DeadlinesApi };
var templateObject_1;
